import { ThemeProvider } from 'bonfire-kindling';
import theme from 'constants/theme';

export default ({ children }) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;
